import { Button } from '@mantine/core'
import { useNavigate } from 'react-router-dom'
import { useDuplicateReviewForPatient } from '@/hooks/usePatientMerge'

/** Chart-header row shown when an open duplicate review names this patient. */
export function DuplicateReviewBanner({ patientId }: { patientId: string }) {
  const navigate = useNavigate()
  const { data } = useDuplicateReviewForPatient(patientId)
  const reviewId = data?.reviewId
  if (!reviewId) return null

  return (
    <div
      role="status"
      data-testid="duplicate-review-banner"
      className="flex w-full basis-full items-center justify-between gap-3 rounded-md border border-amber-300 bg-amber-50 px-3 py-1.5 text-sm text-amber-900"
    >
      <span>Possible duplicate found</span>
      <Button
        size="compact-xs"
        variant="light"
        color="amber"
        onClick={() => void navigate(`/patients/duplicates/${reviewId}`)}
      >
        Review records
      </Button>
    </div>
  )
}
